export default __webpack_public_path__ + "maps-examples-image-source-thumbnail-480-1de22f90c2614d983235cca70cb1e40f.png";